import cn from '@integrations/classnames'
import type { HTMLAttributes } from '@integrations/react'
import styles from './ProCard.module.scss'

interface ProCardProps extends HTMLAttributes<HTMLDivElement> {
  /** `brand` is the solid Banky-blue hero (Overview, Accounts); `action` the yellow one (Refer & Earn). */
  tone?: 'default' | 'brand' | 'action'
}

function ProCard({ className, children, tone = 'default', ...props }: ProCardProps) {
  return (
    <div
      className={cn(styles['pro-card'], 'pro-card', className, {
        [styles['pro-card--brand']]: tone === 'brand',
        'pro-card--brand': tone === 'brand',
        [styles['pro-card--action']]: tone === 'action',
        'pro-card--action': tone === 'action'
      })}
      {...props}
    >
      {children}
    </div>
  )
}

export default ProCard
